import React from 'react';
import { TYPE_THEMATIQUE } from '../../../constants';
import './Summary.scss';
import CategoryContainer from "./category/CategoryContainer";
import {faCheck, faTimes} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const Summary = props => {
  const {type, questions, categories, score, max, success, resultText} = props;

  const summaryScore = max === 'm' ? (
    <FontAwesomeIcon icon={success ? faCheck : faTimes} size='2x'/>
  ) : (
    <span>{score}/{questions.length}</span>
  );

  const categoriesJsx = categories.map(c => <li key={c.code}><CategoryContainer category={c}/></li>);
  const resultDetails = type !== TYPE_THEMATIQUE ? (
    <React.Fragment>
      <p className='summary__text'>{resultText}</p>
      <h2 className='summary__title'>Résultats par catégorie</h2>
      <ul className='summary__categories'>
        {categoriesJsx}
      </ul>
    </React.Fragment>
  ) : null;

  return (
    <section className="summary">
      <div className={'summary__score ' + (success ? 'success' : 'failure')}>
        {summaryScore}
      </div>
      {resultDetails}
    </section>
  );
};

export default Summary;
